import BaseResource from './BaseResource'

export default class RfidReadersFull extends BaseResource {
  static endpoint = '/api/v1/rfidReadersFull' ///edge
}
